import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Close, Download } from '@mui/icons-material';
import { FileWidget } from 'src/views/CorporateOnboarding/common';
import { useState, useEffect } from 'react';
import { S3_BASE_URL, BUCKET_NAME } from 'src/config';
import { download } from 'src/utils/download';
import moment from 'moment';
import { formatDisplayDate } from 'careit';
import { useTranslation } from 'react-i18next';

export function getUrl(fileUrl) {
  return `${S3_BASE_URL}/${BUCKET_NAME}/${fileUrl}`;
}

const ViewDocument = ({ name, url, useLegacyPdfHandling = false }) => {
  const [_url, setUrl] = useState(null);

  useEffect(() => {
    if (!url) return;
    const lower = (name || url || '').toLowerCase();
    const isPdf = lower.endsWith('.pdf');

    if (useLegacyPdfHandling && isPdf) {
      // Old documents didn't have Content Type: application/pdf . That is why the blob is being created.
      fetch(getUrl(url))
        .then((res) => res.blob())
        .then((blob) => {
          const pdfBlob = new Blob([blob], { type: 'application/pdf' });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          setUrl(pdfUrl);
        });
    } else {
      setUrl(getUrl(url));
    }
  }, [url, name, useLegacyPdfHandling]);

  return <FileWidget name={name} url={_url} hideDownload={true} />;
};

export default function PreviewDocument({
  open,
  onClose,
  documentName,
  documentUrl,
  title,
  onDownload,
  downloadFileName,
  createdDate,
  useLegacyPdfHandling = false,
}) {
  const { t } = useTranslation();
  const handleDownload = () => {
    if (onDownload) {
      onDownload();
    } else {
      download(getUrl(documentUrl), downloadFileName || documentName);
    }
  };

  return (
    <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 2,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <Typography variant="h6">{title || documentName}</Typography>
            {createdDate && (
              <Typography variant="body2" color="text.secondary">
                {t('preview-document.created-on', {
                  date: formatDisplayDate(moment(createdDate), 'date'),
                })}
              </Typography>
            )}
          </Box>

          <Stack direction="row" height="fit-content">
            <IconButton onClick={handleDownload}>
              <Download />
            </IconButton>

            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ '& > div': { height: '70vh' } }}>
          <ViewDocument
            name={documentName}
            url={documentUrl}
            useLegacyPdfHandling={useLegacyPdfHandling}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
